/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_ForbiddenInputs */

const cs_api_error_forbidden = /** @type {(inputs: Api_Error_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na tuto akci nemáte oprávnění.`)
};

const en_api_error_forbidden = /** @type {(inputs: Api_Error_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission for this action.`)
};

/**
* | output |
* | --- |
* | "You do not have permission for this action." |
*
* @param {Api_Error_ForbiddenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_forbidden = /** @type {((inputs?: Api_Error_ForbiddenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_ForbiddenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_forbidden(inputs)
	return cs_api_error_forbidden(inputs)
});